<template>
<div class="page-container">
  <el-breadcrumb separator="/">
    <el-breadcrumb-item>
      <span class="page-title">审批</span>
    </el-breadcrumb-item>
    <el-breadcrumb-item>KYC认证审批</el-breadcrumb-item>
  </el-breadcrumb>
  <el-card class="page-content">
    <el-tabs v-model="kycType" @tab-click="handleKycChange">
      <el-tab-pane label="基础身份认证" name="1"></el-tab-pane>
<!--      <el-tab-pane label="高级实名认证" name="2"></el-tab-pane>-->
    </el-tabs>
    <el-tabs v-model="activeTab" @tab-click="handleTabChange">
      <el-tab-pane label="审核中" name="2"></el-tab-pane>
      <el-tab-pane label="未认证" name="0"></el-tab-pane>
      <el-tab-pane label="已认证" name="1"></el-tab-pane>
      <el-tab-pane label="审核不通过" name="3"></el-tab-pane>
      <el-tab-pane label="黑名单" name="-1"></el-tab-pane>
    </el-tabs>
    <div class="actions-bar">
      <el-input placeholder="请输入账号UID/账户/姓名" clearable v-model="keywords">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-button type="primary" @click="handleSearch">搜索</el-button>
    </div>
    <audit-list @refresh="refreshList($event)"></audit-list>
  </el-card>
</div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import AuditList from './components/list';
import { PAGINATION } from './constants';
import api from './api';


export default {
  name: 'KYC',
  data() {
    return {
      keywords: null,
      activeTab: '2',
      kycType: '1'
    };
  },
  components: {
    AuditList
  },
  computed: {
    ...mapState('kycAudit', ['pagination'])
  },
  methods: {
    ...mapActions('kycAudit', ['list','clearAuditList',"groupInit"]),
    handleKycChange(tab) {
      this.keywords = null;
      this.kycType = tab.name
      // if (tab.name == "1") {
        this.list({ identityAuthType: tab.name, status: this.activeTab, ...PAGINATION });
      // }else {
      //   this.clearAuditList();
      // }
    },
    handleTabChange(tab) {
      this.keywords = null;
      // if (tab.name == "0") {
        this.list({ identityAuthType: this.kycType, status: tab.name, ...PAGINATION });
      // }else {
      //   this.clearAuditList();
      // }
    },
    handleSearch() {
      this.list({
        identityAuthType: this.kycType,
        status: this.activeTab,
        keywords: this.keywords,
        ...PAGINATION
      });
    },
    refreshList(data = {}) {
      this.list({
        identityAuthType: this.kycType,
        status: this.activeTab,
        keywords: this.keywords,
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.list({ identityAuthType: 1, status: 2, page: 1, size: 25 });
    this.groupInit();


  }
};
</script>

<style lang="less" scoped>
.actions-bar {
  display: flex;
  align-items: center;
  .el-input {
    width: 300px;
    margin-right: 10px;
  }
}
</style>
